import { UI_CARD_INTERACTIVE } from "lib/uiClasses";

const Widget = (props: { icon: JSX.Element; title: string; subtitle: string }) => {
  const { icon, title, subtitle } = props;

  return (
    <div
      className={`!z-5 flex h-full ${UI_CARD_INTERACTIVE} !flex-row items-center gap-3 rounded-2xl p-4 sm:gap-4 sm:p-5`}
    >
      <div className="flex shrink-0 items-center justify-center">
        <div className="apple-metric-icon rounded-full bg-lightPrimary p-3 dark:border dark:border-white/[0.06] dark:bg-surface-elevated">
          <span className="flex items-center text-brand-500 dark:text-brand-400">{icon}</span>
        </div>
      </div>
      <div className="flex min-w-0 flex-1 flex-col justify-center">
        <p className="truncate text-xs font-medium text-gray-600 dark:text-slate-400 sm:text-sm">
          {title}
        </p>
        <h4 className="truncate text-lg font-bold text-navy-700 dark:text-slate-50 sm:text-xl">
          {subtitle}
        </h4>
      </div>
    </div>
  );
};

export default Widget;
